import axios from "axios";
import { appConfigs } from "../../martin/_helpers";

export function getApp(data) {
  return axios.post(appConfigs.api_url + 'get-app', { data });
}

export function getApps(data) {
  return axios.post(appConfigs.api_url + 'get-apps', { data });
}

export function createApp(data) {
  return axios.post(appConfigs.api_url + 'create-app', { data });
}

export function updateApp(data) {
  return axios.post(appConfigs.api_url + 'update-app', { data });
}

export function getCategories(data) {
  return axios.post(appConfigs.api_url + 'get-categories', { data });
}

export function getAccount(data) {
  return axios.post(appConfigs.api_url + 'get-user-from-hex', { data });
}

export function resendVerification(data) {
  return axios.post(appConfigs.api_url + 'resend-verification', data);
}

export function verifyEmail(data) {
  return axios.post(appConfigs.api_url + 'verify-email', data);
}

export function getSettings(data) {
  return axios.post(appConfigs.api_url + 'get-settings', { data });
}

export function createCategory(data) {
  return axios.post(appConfigs.api_url + 'create-category', { data });
}

export function deleteCategory(data) {
  return axios.post(appConfigs.api_url + 'delete-category', { data });
}

export function updateCategory(data) {
  return axios.post(appConfigs.api_url + 'update-category', { data });
}

export function updateSettings(data) {
  return axios.post(appConfigs.api_url + 'update-settings', { data });
}
export function checkToken(data) {
  return axios.post(appConfigs.api_url + 'token', { data });
}

export function search(data) {
  return axios.post(appConfigs.api_url + 'search', { data });
}
